import { LogsService } from "@gtpl/shared-services/user-logs";
import { Injectable } from "@nestjs/common";
import { CostSheetRepo } from "./repository/costing-repo";
import { ConfirmedContainersReq, ContainersReq, CostSheetModel, CostingSheetResponse,EnquiryAssessmentResponseModel, EnquiryAssessmentUpdateReq, EnquiryIdreq, EnquiryLifecycleStatusEnum, QuoteRequest, getAllEnquiryInfoReq,productRates,StyleWeighmentEnum, CostingDestinationReq } from "@gtpl/shared-models/enquiry-management";
import { CommonResponse, FgPriceListCategoryEnum, GlobalPriceType, TypeEnum } from "@gtpl/shared-models/masters";
import { CommandOptions, Repository, TransactionManager, getManager } from "typeorm";
import appSettings from "apps/services/config";
import { CostSheetEntity } from "./entity/cost-sheet-entity";
import { EnquiryLogEntity } from "../enquiries/entites/enquiry-log";
import { EnquiriesEntity } from "../enquiries/entites/enquiries";
import { InjectRepository } from "@nestjs/typeorm";
import { EnquiryProdctsEntity } from "../enquiries/entites/enquiry-products";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { MFGCostsEntity } from "./entity/mfg-costs-entity";
import { FreightForwardExpensesEntity } from "./entity/freight-forward-expenses-entity";
import { EnquiriesRepository } from "../enquiries/repositories/enquiries.repo";
import { EnquiriesProductsRepository } from "../enquiries/repositories/enquiry-products-repo";
import { CategoryEnum, GlobalVariableValues, HarvestTypes, PackingCategoryEnum } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from '@gtpl/shared-models/raw-material-procurement';
import { UnitsOfWeightInput } from "@gtpl/shared-models/sale-management";
import {DestinationService} from '@gtpl/shared-services/masters'

@Injectable()
export class CostingService {
    constructor(
        @InjectRepository(EnquiryLogEntity)
        private enquiryLogRepo: Repository<EnquiryLogEntity> ,
                private readonly  costSheetRepo: CostSheetRepo ,
                private enquiryRepo:EnquiriesRepository,
                private enquiryProductsRepo:EnquiriesProductsRepository,
        private logService:LogsService,
        @InjectRepository(EnquiriesEntity)
        private enquiriesRepo: Repository<EnquiriesEntity>,
        private destinationService:DestinationService

    ) {}
    async getQuotationSentEnquiries(req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.enquiry_id AS enquiryId,e.enquiry_number AS enquiryNumber,
            e.country_id AS countryId,c.country_name AS countryName,
            e.destination_id AS destinationId,d.destination_name AS destination,
            e.unit_id,u.unit_name AS unitName,
            e.source_from as sourceFrom,
            e.agent_id,CONCAT(cus.client_code,'-',cus.client_name)AS agent,
            e.buyer_id,CONCAT(ec.end_customer_code,'-',ec.end_customer_name) AS buyer,
            e.etd,DATEDIFF(NOW(), e.updated_at) AS aging,e.enquiry_date as enquiryDate
            FROM enquiries e
            LEFT JOIN `+appSettings.masters_db+`.countries c ON e.country_id = c.country_id
            LEFT JOIN `+appSettings.masters_db+`.destination d ON d.destination_id = e.destination_id
            LEFT JOIN `+appSettings.masters_db+`.unitcodes u ON u.unit_code_id = e.unit_id
            LEFT JOIN `+appSettings.masters_db+`.customers cus ON cus.cust_id = e.agent_id
            LEFT JOIN `+appSettings.masters_db+`.end_customers ec ON ec.end_customer_id = e.buyer_id WHERE 1=1`
            if(req.tabName != undefined){
                if(req.tabName == 'QUOTATION SENT'){
                    query = query + ` and e.life_cycle_status = "QUOTATION SENT"`
                }
                if(req.tabName == 'ACCEPTANCE PENDING'){
                    query = query + ` and e.life_cycle_status = "ACCEPTANCE PENDING"`
                }
            }
            if(req.enquiryNo != undefined){
                query=query+` and e.enquiry_number= '${req.enquiryNo}'`
            }
            
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getEnquiryNo (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT enquiry_id AS enquiryId, enquiry_number AS enquiryNo FROM enquiries WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and life_cycle_status ='${req.tabName}'`
            }
            query = query + ` GROUP BY enquiry_id ORDER BY enquiry_number`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async confirmEnquiry(req:EnquiryAssessmentUpdateReq):Promise<CommonResponse>{
        return null
    }

    async getExchangeRate(enquiryId:number,currencyId:number){
        const manager = getManager()
        const exchangeRatesQry = `SELECT exchange_rate as exchangeRate FROM ${appSettings.masters_db}.exchange_rates WHERE currency_id = ${currencyId} AND effective_from < DATE(NOW()) ORDER BY effective_from DESC LIMIT 1`
        return await manager.query(exchangeRatesQry)
    }

    async getOcenFrightOfEnquiry(countryId?:number,destinationId?:number){
        console.log(countryId,destinationId,"countryId,destinationId")
        const manager = getManager()
        // let oceanFrieghtRateQry = `SELECT avg(total) as oceanFreightRateUSD FROM ${appSettings.masters_db}.ocaen_freight_rates WHERE 1=1`
        let oceanFrieghtRateQry = `SELECT total as oceanFreightRateUSD FROM ${appSettings.masters_db}.ocaen_freight_rates WHERE 1=1`
        if(countryId!=null||undefined){
            oceanFrieghtRateQry+=` AND country_id = ${countryId}`
        }
        if(destinationId!=null||undefined){
            oceanFrieghtRateQry+=` AND destination_id = ${destinationId}`
        }
        oceanFrieghtRateQry += ` ORDER BY DATE(updated_at) DESC LIMIT 1`
        console.log(oceanFrieghtRateQry,"+++++++++++")
        return await manager.query(oceanFrieghtRateQry)

    }

    async generateCostSheet(req:EnquiryIdreq):Promise<CostingSheetResponse>{
        //get basic details of an enqiry
        const manager=getManager()
        const transmanager = new GenericTransactionManager();
        await transmanager.startTransaction()
        if(req.operation == 'regenerate'){
            console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1')
            console.log('regenerate')
            const deletePreviousRecord = await transmanager.getRepository(CostSheetEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
            console.log(deletePreviousRecord)
            if(deletePreviousRecord.affected){
                const deleteFrieghtForwardExp = await transmanager.getRepository(FreightForwardExpensesEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
                if(deleteFrieghtForwardExp.affected){
                const deleteMfgCosts = await transmanager.getRepository(MFGCostsEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
                if(deleteMfgCosts.affected){
                    console.log('ok')
                    const updateStatus = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryid},{lifeCycleStatus:EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED,isRegenearted:true})
                    if(!updateStatus.affected){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Something went wrong in updating status in enquiries')
                    }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in MFG costs')
                }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in Freight and Forward Expenses')
                }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in cost sheet')
                }
        }
        //need to check if cost sheet generated or not for the selected Enquiry
        const checkCostSheet = await transmanager.getCustomRepository(CostSheetRepo).count({where:{enquiryEntity:{enquiryId:req.enquiryid}}})
        console.log(checkCostSheet,'checkcostsheet')
        if(!(checkCostSheet > 0)){
            console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^6')
            const enquiryInfo = await this.enquiryRepo.getEnquiryDetailsForCostSheet(req.enquiryid)
            if(enquiryInfo.length > 0){
                const datesInfo = await this.enquiryRepo.getEnquiryStatusInfo(req.enquiryid)
                //datesInfo.assesmentApprovalDate
                const exchangeRate = await this.getExchangeRate(req.enquiryid,enquiryInfo[0].currencyId)
                //exchangeRate[0]
                if(exchangeRate.length > 0){
                    //get ocean fright rate in USD against country and destination from ocean freight rates data
                    const oceanFrieghtRate = await this.getOcenFrightOfEnquiry(enquiryInfo[0]?.countryId,enquiryInfo[0]?.destinationId) 
                    if((oceanFrieghtRate[0]?.oceanFreightRateUSD == null)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'No Ocean freight rate found for selected enquiry')
                    }
                    //product against cost sheet rates
                    //1.yield
                    const enquiryProducts = await this.enquiryProductsRepo.getEnquiryProductsForEnquiry(req.enquiryid)
                    //container wise products list map
                    const containerProductsMap = new Map<number,number>()
                    let groupQty = 0
                    for(const productitem of enquiryProducts){
                        if(UnitsOfWeightInput.find(item => item.value == productitem.uomId).name == 'lb'){
                            groupQty = (productitem.shrimpQty)*0.454
                        }else if(UnitsOfWeightInput.find(item => item.value == productitem.uomId).name == 'oz'){
                            groupQty = ((productitem.shrimpQty)/16)*0.454
                        }
                        else if(UnitsOfWeightInput.find(item => item.value == productitem.uomId).name == 'gm'){
                            groupQty = (productitem.shrimpQty)/1000
                        }
                        else{
                            groupQty = productitem.shrimpQty
                        }
                        if(containerProductsMap.has(productitem.group)){
                            const prevQty = containerProductsMap.get(productitem.group)
                            containerProductsMap.set(productitem.group,(Number(prevQty)+Number(groupQty)))
                        }else{
                            containerProductsMap.set(productitem.group,groupQty)
                        }
                    }
    
                    //yield percentages data with map
                    const variantIdsQry = `select group_concat(distinct(variant_id)) as variantId from ${appSettings.enquiry_db}.enquiry_products where enquiry_id = ${req.enquiryid} `
                    const variantData = await manager.query(variantIdsQry)
                    const yieldPerQry = `SELECT sku_code_id as variantId,loss_or_gain_percentage as yieldper,food_type_id as foodTypeId,value_addition_one_id as valoneId,value_addition_two_id as valtwoId,value_addition_three_id as valthreeId,grades.grade_min_count as minGrade,grade_max_count as maxGrade FROM ${appSettings.masters_db}.sku_codes 
                    left join ${appSettings.masters_db}.grades on grades.grade_id = sku_codes.grade_id
                    WHERE sku_code_id in (${variantData[0].variantId})`
                    const yieldData = await manager.query(yieldPerQry)
                    if(!(yieldData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'yield percentage not found')
                    }
                    const yieldPerMap = new Map<number,number>()
                    //peeling rates
                    let foodTypes = []
                    let valAddOnes = []
                    let valAddTwos = []
                    let valAddThrees = []
                    let minGrades = []
                    let maxGrades = []
                    interface peelingModel{
                        foodTypeId:number,
                        valaddOneId:number,
                        valaddTwoId:number,
                        valaddThreeId:number,
                        minGrade:number,
                        maxGrade:number,
                    }
                    yieldData.forEach(rec => {
                        if(!yieldPerMap.has(rec.variantId)){
                            yieldPerMap.set(rec.variantId,rec.yieldper)
                        }
                        if(!(valAddOnes.includes(rec.valoneId))){
                            valAddOnes.push(rec.valoneId)
                        }
                        if(!(valAddTwos.includes(rec.valtwoId))){
                            valAddTwos.push(rec.valtwoId)
                        }
                        if(!(valAddThrees.includes(rec.valthreeId))){
                            valAddThrees.push(rec.valthreeId)
                        }
                        if(!(minGrades.includes(rec.minGrade))){
                            minGrades.push(rec.minGrade)
                        }
                        if(!(maxGrades.includes(rec.maxGrade))){
                            maxGrades.push(rec.maxGrade)
                        }
                        if(!(foodTypes.includes(rec.foodType))){
                            foodTypes.push(rec.foodTypeId)
                        }
                        
                    });

                    //packCount 
                    
                    
                    // yieldData.forEach(rec => {
                    //     console.log(Number(rec.yieldper),'----per')
                    //     if(Number(rec.yieldper) <= 0){
                    //         console.log('7777')
                    //         break
                    //         // return new CostingSheetResponse(false,0,'Yield percentage should not be zero for all products')
                    //     }else{
                    //         if(!yieldPerMap.has(rec.variantId)){
                    //             yieldPerMap.set(rec.variantId,rec.yieldper)
                    //         }
                    //     }
                    // });
                    for(const rec of yieldData){
                        if(Number(rec.yieldper) <= 0){
                            await transmanager.releaseTransaction()
                            return new CostingSheetResponse(false,0,'Yield percentage should not be zero for all products')
                        }else{
                            if(!yieldPerMap.has(rec.variantId)){
                                yieldPerMap.set(rec.variantId,rec.yieldper)
                            }
                        } 
                    }
                    //pack count
                    //dependency need to add in grades master and enquiry form
                    //rmRate should get from from rate chart against the rm count of the product
                    const rmratesMap = new Map<number,number>()
                    const rmratesQry = `SELECT COUNT as count,price FROM ${appSettings.rm_procure_db}.rm_rates where category = '${CompanyCategoryEnum.OWN}' and type = '${HarvestTypes.Re_Weighment}'`
                    const rmratesData = await manager.query(rmratesQry)
                    if(!(rmratesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'RM rates not found')
                    }
                    rmratesData.forEach(element => {
                        if(!(rmratesMap.has(element.count))){
                            rmratesMap.set(Number(element.count),element.price)
                        }
                    });
                    //manufacturing cost is the sum of fixed component rates and peeling rate
                    //fixed component rates
                    // const mfgRatesQry = `SELECT SUM(price) as mfgComponentsCost FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG'`;
                    // const mfgRatesQry = `SELECT SUM(price) AS mfgComponentsCost , SUM(CASE WHEN component = 'Boiler Fuel Cost' THEN 0 ELSE price END) AS mfgCostWithoutBoilerFuel FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG'
                    // `;
                    // const mfgRatesData = await manager.query(mfgRatesQry)
                    //if pack category wise prices having then it should be added to mfg cost
                    const mfgRatesQry = `SELECT sum(price)AS mfgwithBoilerCost,packing_category as packCategory,SUM(CASE WHEN component = 'Boiler Fuel Cost' THEN 0 ELSE price END) AS mfgCostWithoutBoilerFuel FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG' group by packing_category`;
                    const mfgRatesData = await manager.query(mfgRatesQry)
                    if(!(mfgRatesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'MFG component rates not found')
                    }
                    let mfgRatesMap = new Map<string, {withBoilerCost:number,withoutBoilerCost:number}>()
                    for(const rec of mfgRatesData){
                        if(!(mfgRatesMap.has(rec.packCategory))){
                            mfgRatesMap.set(rec.packCategory,{withBoilerCost:rec.mfgwithBoilerCost,withoutBoilerCost:rec.mfgCostWithoutBoilerFuel})
                        }
                    }
                    //mfgRatesData[0].mfgComponentsCost
                    //peeling Rates
                    let peelingrateMap = new Map<string,string>()
                    const pellingInfoQry = `SELECT min_grade as minGrade,max_grade as maxGrade,rate_per_kg as price,food_type_id as foodTypeId,value_add_1 as valoneId,value_add_2 as valtwoId,value_add_3 as valthreeId  FROM ${appSettings.masters_db}.deheading_peeling_chart WHERE min_grade IN(${minGrades}) AND max_grade IN(${maxGrades}) AND food_type_id IN(${foodTypes}) AND value_add_1 IN(${valAddOnes}) AND 
                    value_add_2 IN(${valAddTwos}) and value_add_3 IN(${valAddThrees})`
                    const peelingRatesInfo = await manager.query(pellingInfoQry)
                    if(!(peelingRatesInfo.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'No Peeling Rates found')
                    }
                    for(const peelingRatesRec of peelingRatesInfo){
                        const peelingPriceObj = {foodTypeId:peelingRatesRec.foodTypeId,
                            valaddOneId:peelingRatesRec.valoneId,
                            valaddTwoId:peelingRatesRec.valtwoId,
                            valaddThreeId:peelingRatesRec.valthreeId,
                            minGrade:peelingRatesRec.minGrade,
                            maxGrade:peelingRatesRec.maxGrade}
                            const mapKey = JSON.stringify(peelingPriceObj)
                        if(!peelingrateMap.has(mapKey)){
                                peelingrateMap.set(mapKey,peelingRatesRec.price)
                            }
                    }
                    //pack material cost should fetch against product and pack style  from packing material price chart
                    // let packmaterialMap = new Map<number,Map<number,number>>() //product,packstyle,price
                    // const packMaterialQuery = `select product_id as productId,pack_style_id as packStyleId,price from ${appSettings.masters_db}.packing_material_prices where product_id in(${variantData[0].variantId})`
                    // const packMaterialnfo = await manager.query(packMaterialQuery)
                    // if(!(packMaterialnfo.length > 0)){
                    //     return new CostingSheetResponse(false,0,'Pack Material price rates not found')
                    // }
                    // for(const packMateriaRec of packMaterialnfo){
                    //     if(!(packmaterialMap.has(packMateriaRec.productId))){
                    //         packmaterialMap.set(packMateriaRec.productId,new Map<number,number>())
                    //         if(!(packmaterialMap.get(packMateriaRec.productId).has(packMateriaRec.packStyleId))){
                    //             packmaterialMap.get(packMateriaRec.productId).set(packMateriaRec.packStyleId,packMateriaRec.price)
                    //         }
                    //     }else{ 
                    //         if(!(packmaterialMap.get(packMateriaRec.productId).has(packMateriaRec.packStyleId))){
                    //             packmaterialMap.get(packMateriaRec.productId).set(packMateriaRec.packStyleId,packMateriaRec.price)
                    //         }
                    //     }
                    // }
                    // return new CostingSheetResponse(false,0,'found')

                    
                    //Freight and Farward Expenses are the sum of ocean freigh charge for destination and fixed forwarding prices
                    console.log('wwwwwwwwwwwwwwwwwwwwwwww')
                    const oceanFreightInUsd = enquiryInfo[0].isFOB == 0 ? 0 : oceanFrieghtRate[0]?.oceanFreightRateUSD
                    //global forwarding prices
                    const globalPricesQry = `SELECT component,price,type FROM ${appSettings.masters_db}.global_price_chart where is_costing = 1`
                    const globalPricesData = await manager.query(globalPricesQry)
                    if(!(globalPricesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Global price rates not found')
                    }
                    // let totalGlobalPrice = 0
                    // globalPricesData.forEach(priceRec => {
                    //     if(priceRec.component == 'Antidumping duty'){
                    //         totalGlobalPrice += priceRec.price
                    //     }
                    // });
                    //fixed cost claculation will be the sum of all fixed component prices
                    const fixedRates = `SELECT SUM(price) as fixedCost FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'Fixed'`;
                    const fixedRatesData = await manager.query(fixedRates)
                    if(!(fixedRatesData.length >0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Fixed cost component rates not found')
                    }
                    //quoteSent Enquiries..If quotation sent then quote price should be fetch
                    interface QuoteInfo {
                        quotePrice:number,
                        addedPriceToRmrate:number,
                        reducedPriceToRmRate:number,
                        costOfSalesForAddedRmRate:number,
                        costOfSalesForReducedRmRate:number,
                        quoteStatus:number,
                        incentives:number
                    }
                    // const qouteDetailsMap = new Map<number,QuoteInfo>()
                    // let quoteSentFlag:boolean = false
                    // let quoteconcatString = 'quote_status = 1'
                    
                    // const quoteSentEnquiriesQry = commonQry+`${quoteconcatString}`
                    // const quoteSentEnquiriesData = await manager.query(quoteSentEnquiriesQry)
                    // if((quoteSentEnquiriesData.length > 0)){
                    //     console.log(quoteSentEnquiriesData,'quoteSentEnquiriesData')
                    //     quoteSentFlag = true
                    //     quoteSentEnquiriesData.forEach(rec => {
                    //         if(!(qouteDetailsMap.has(rec.variantId))){
                    //             qouteDetailsMap.set(rec.variantId,{
                    //                 quotePrice:rec.quotePrice,
                    //                 addedPriceToRmrate:rec.addedPriceToRmrate,
                    //                 reducedPriceToRmRate:rec.reducedPriceToRmRate,
                    //                 costOfSalesForAddedRmRate:rec.costOfSalesForAddedRmRate,
                    //                 costOfSalesForReducedRmRate:rec.costOfSalesForReducedRmRate,
                    //                 quoteStatus:rec.quoteStatus,incentives:rec.incentives})
                    //         }
    
                    //     })
                    //     console.log(qouteDetailsMap)
                    // }
                    //If buyer offer price captired after quotation sent then need to fetch the details from below query
                    interface OfferPriceInfo {
                        netPLOnBuyerPrice:number,
                        totalProfitLoss:number,
                        buyerOfferPrice:number,
                        plPercentage:number,
                        contributionPercentage:number,
                    }
                    const buyerPriceDataMap = new Map<number,OfferPriceInfo>()
                    let buyerOfferPriceFlag:boolean = false
                    // let buyerPriceconcatString = 'and buyer_offer_price > 0'
                    // const buyerOfferPriceInfoQry = commonQry+`${buyerPriceconcatString}`
                    const buyerOfferPriceData = await transmanager.getCustomRepository(CostSheetRepo).getBuyerOfferPriceOfEnquiry(req.enquiryid,variantData[0].variantId,transmanager)
                    if(buyerOfferPriceData.length > 0){
                        buyerOfferPriceFlag = true
                        buyerOfferPriceData.forEach(priceItem => {
                            if(!(buyerPriceDataMap.has(priceItem.variantId))){
                                buyerPriceDataMap.set(priceItem.variantId,{
                                    netPLOnBuyerPrice:priceItem.netpl,
                                    totalProfitLoss:priceItem.totalPl,
                                    buyerOfferPrice:priceItem.buyerOfferPrice,
                                    plPercentage:priceItem.plPercentage,
                                    contributionPercentage:priceItem.contributionPercentage
                                })
                            }
                        });
                    }
                    //prevailing FG market rate
                    let ProductPriceInfoMap = new Map<number,number>()
                    const fgProductPriceQry = `SELECT product_id AS variantId,min_price as price FROM ${appSettings.masters_db}.product_price_list WHERE product_id IN(${variantData[0].variantId}) and category = '${FgPriceListCategoryEnum.EXPORT}'`
                    const fgProductPriceData = await manager.query(fgProductPriceQry)
                    // if(fgProductPriceData.length != (variantData[0].variantId.split(',')).length){
                    //     await transmanager.releaseTransaction()
                    //     return new CostingSheetResponse(false,0,'No Market Rates found for product')
                    // }
                    fgProductPriceData.forEach(productPriceRec=>{
                        if(!(ProductPriceInfoMap.has(productPriceRec.variantId))){
                            ProductPriceInfoMap.set(productPriceRec.variantId,productPriceRec.price)
                        }
                    })
                    //previous confirmed price
                    let prevEnquiryDataMap = new Map<number,number>()//variantid,price
                    let sameBuyerEnquiriesMap = new Map<number,number>()//variantid,price
                    let prevenquiriesFlag:boolean = false
                    let sameBuyerEnquiryFlag:boolean = false

                    //check the previous confirmed enquiries with same buyer
                    const prevConfirmedEnquiriesData = await this.enquiryRepo.getPrevConfirmedEnquiries(variantData[0].variantId)
                    const sameBuyerPrevEnquiryData = await this.enquiryRepo.getSameBuyerConfirmedEnquiries(variantData[0].variantId,enquiryInfo[0].buyerId)
                    if(sameBuyerPrevEnquiryData.length > 0){
                        sameBuyerEnquiryFlag = true
                        sameBuyerPrevEnquiryData.forEach(record => {
                            if((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/0.454
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 1 || record.uomId == 4)){
                                record.unitPrice = record.unitPrice/record.caseWeight
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/(0.454*record.caseWeight)
                            }
                            if(!sameBuyerEnquiriesMap.has(record.prodct)){
                                sameBuyerEnquiriesMap.set(record.variantId,record.unitPrice)
                            }
                        });
                    }
                    let unitPricemap = new Map<number,number>()//variantid,price
                    if(prevConfirmedEnquiriesData.length > 0){
                        prevenquiriesFlag = true
                        //assign avarage of all prices for one variant
                        let avgPrice = 0
                        let unitPrice = 0
                        let prevUnitPrice = 0
                        let totalProducts = 0
                        prevConfirmedEnquiriesData.forEach((record,index) => { 
                            if((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/0.454
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 1 || record.uomId == 4)){
                                record.unitPrice = record.unitPrice/record.caseWeight
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/(0.454*record.caseWeight)
                            }
                            if(!(prevEnquiryDataMap.has(record.variantId))){    
                                prevEnquiryDataMap.set(record.variantId,record.unitPrice)
                                unitPricemap.set(record.variantId,record.unitPrice)  
                            }else{
                                unitPrice = Number(unitPricemap.get(record.variantId))+Number(record.unitPrice)
                                unitPricemap.set(record.variantId,unitPrice)
                                prevUnitPrice = unitPricemap.get(record.variantId)
                                totalProducts += 1
                                avgPrice = prevUnitPrice/(totalProducts+1)
                                prevEnquiryDataMap.set(record.variantId,avgPrice)
                            }
                        });
                    }
                    let ocaenFreightPerKg
                    let productPricesData = []
                    let adPer = 0
                    let cvdPer = 0
                    for(const product of enquiryProducts){
                        //shrimp qty based on container,if multiple products having in same container then quantity based calculations should be done for sum of tow products qty
                        // if(UnitsOfWeightInput.find(item => item.value == product.uomId).name == 'lb'){
                            product.shrimpQty = containerProductsMap.get(product.group)
                        // }
                        //yield
                        const yieldVal = yieldPerMap.get(product.variantId)
                        //frozen Yield
                        //if style weighment is FWFC or NWFC rmcount should caculate on frozen yield
                        let frozenyield
                        if(product.styleWeighment == StyleWeighmentEnum.FWFC || product.styleWeighment == StyleWeighmentEnum.NWFC){
                            frozenyield = Number(yieldVal)+Number(yieldVal*(product.glaze/100))
                        }
                        const packCount = product.packCount
                        //RM count calculation
                        let rmCount
                        //rmcount for frozen counts and net counts 
                        if(product.styleWeighment == StyleWeighmentEnum.FWFC || product.styleWeighment == StyleWeighmentEnum.NWFC){
                            rmCount = Math.round(1000/((454/packCount/frozenyield)*100))
                        }else{
                            rmCount = Math.round(1000/((454/packCount/yieldVal)*100))
                        }
                        console.log(rmCount,'countval')
                        // console.log(rmCount,'rmCountkkk')
                        //prevailing rmrate
                        const rmRate = rmratesMap.get(rmCount) ? rmratesMap.get(rmCount) : 0
                        if(rmratesMap.get(rmCount) == undefined){
                            await transmanager.releaseTransaction()
                            return new CommonResponse(false,0,'Rm rate not found for the count')
                        }
                        //rm cost calculation
                        const rmCost = Math.round(rmRate/(yieldVal/100))
                        //mfgcost = mfgcomponents cost+peeling cost per kg
                        const key = {
                            foodTypeId: product.foodTypeId,
                            valaddOneId: product.valoneId,
                            valaddTwoId: product.valtwoId,
                            valaddThreeId: product.valthreeId,
                            minGrade: Number(product.minGrade),
                            maxGrade: Number(product.maxGrade)
                        };

                        console.log()

                        const peelingCost = peelingrateMap.get(JSON.stringify(key))
                        if(peelingCost == undefined){
                            await transmanager.releaseTransaction()
                            return new CommonResponse(false,0,'Peeling cost is not defined for product')
                        }
                        console.log(mfgRatesMap)
                        console.log(product.category)
                        if(mfgRatesMap.get(product.category) == undefined){
                            mfgRatesMap.set(product.category,{withBoilerCost:0,withoutBoilerCost:0})
                        }
                        let mfgComponentCost = product.foodTypeId == GlobalVariableValues.cookingId ? Number((mfgRatesMap.get('ALL').withBoilerCost)+(mfgRatesMap.get(product.category).withBoilerCost)) : Number((mfgRatesMap.get('ALL').withoutBoilerCost)+(mfgRatesMap.get(product.category).withoutBoilerCost))
                        const mfgCost = Math.round(Number(mfgComponentCost)+Number(peelingCost))
                        //salecommissiion directly capturing from enquiry(percentage)
                        const saleCommPer = enquiryInfo[0].saleCommissionPercentage
                        const saleCommission = Math.round(((product.shrimpQty/0.454)*(saleCommPer/100)*(exchangeRate[0].exchangeRate))/product.shrimpQty)
                        //pack material cost
                        // const packmaterailCost = packmaterialMap.get(product.variantId).get(product.packStyleId)
                        const packmaterailCost = product.packMaterialCost
                        // const packmaterailCost = 14 //uncomm
                        //Freight and Farward Expenses are the sum of ocean freigh charge for destination and fixed forwarding prices
                        ocaenFreightPerKg = (oceanFreightInUsd*(Number(exchangeRate[0].exchangeRate)+4))/product.shrimpQty
                        let totalGlobalPrice = 0
                        let percentageSum = 0
                        
                        let percentageVal = 0

                        globalPricesData.forEach(priceRec => {
                            if(priceRec.type == GlobalPriceType.Value){
                                totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                                // totalGlobalPrice += Number(priceRec.price)
                            }
                            // if(enquiryInfo[0].country == 'USA' && priceRec.component == 'Agricultural Marketing Cess'){
                            //     totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                            // }
                            if(priceRec.component == 'Antidumping duty'){
                                adPer = priceRec.price
                            }
                            if(priceRec.component == 'CVD'){
                                cvdPer = priceRec.price
                            }
                            if(priceRec.type == GlobalPriceType.Percentage){
                                percentageSum += Number(priceRec.price)
                            }
                            // else{
                            //     totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                            // }
                        });
                        console.log(ocaenFreightPerKg,'hhhh')
                        console.log(totalGlobalPrice,'hhhmmm')
                        const freightAndForwardExp = Math.round(ocaenFreightPerKg+totalGlobalPrice)
                        //fixedCost
                        const fixedCost = Number(fixedRatesData[0].fixedCost)
                        const totalExpenses = Math.round(mfgCost+Number(saleCommission)+Number(packmaterailCost)+Number(freightAndForwardExp)+fixedCost)
                        //cost of production 
                        const productionCost = Number((((totalExpenses+rmCost)/(exchangeRate[0].exchangeRate))*0.454).toFixed(2))
                        console.log(productionCost,'productionCost')
                        
                        //COST OF SALES PER KG IN INR
                        const costOfSalesPerKgINR = rmCost+totalExpenses
                        //COST OF SALES PER KG IN USD
                        const costOfSalesPerKgUSD = Number((costOfSalesPerKgINR/exchangeRate[0].exchangeRate).toFixed(2))
                        //COST OF SALES PER LB IN USD
                        const costOfSaleUSBVal = Number(costOfSalesPerKgUSD*0.454)
                        let costOfSalesPerLBUSD = Number(costOfSaleUSBVal.toFixed(2))
                        let totCostOfSalesPerLBUSD = costOfSalesPerLBUSD
                        if(enquiryInfo[0].country == 'USA'){
                            percentageVal = costOfSaleUSBVal*Number((percentageSum/100))
                            totCostOfSalesPerLBUSD = Number(costOfSalesPerLBUSD)+Number(percentageVal)
                        }

                        //If Quotation Sent

                        let quotePrice = 0
                        let addedPriceToRmrate = 0
                        let reducedPriceToRmRate = 0
                        let saleCostToAddedRmrate = 0
                        let saleCostToReducedRmrate = 0
                        let incentives = 0
                        // if(quoteSentFlag){
                        //     quotePrice = qouteDetailsMap.get(product.variantId).quotePrice
                        //     addedPriceToRmrate = qouteDetailsMap.get(product.variantId).addedPriceToRmrate
                        //     reducedPriceToRmRate = qouteDetailsMap.get(product.variantId).reducedPriceToRmRate
                        //     saleCostToAddedRmrate = qouteDetailsMap.get(product.variantId).costOfSalesForAddedRmRate
                        //     saleCostToReducedRmrate = qouteDetailsMap.get(product.variantId).costOfSalesForReducedRmRate
                        //     // incentives = ((quotePrice-(oceanFreightInUsd/(product.quantity/0.454)))-(((quotePrice-(oceanFreightInUsd/(product.quantity/0.454))))*(1.35/100)))*(6.60/100)
                        //     incentives = qouteDetailsMap.get(product.variantId).incentives
                        // }
                        //if buyer offer price exists in the enquiry
                        let buyerOfferPrice = 0
                        let netProfitLoss = 0
                        let totalProfitLoss = 0
                        let plPercentage = 0
                        let contributionPercentage = 0
                        let prevConfirmedPrice = 0
                        // percentageVal = 0
                        //to calculate tot cost of sales based on buyer offer price if exists
                        const oceanFreightPrLb = (oceanFreightInUsd)/(product.shrimpQty/0.454)
                        console.log(buyerOfferPriceFlag,'buyerOfferPriceFlag')
                        if(product.buyerOfferPrice > 0 && !buyerOfferPriceFlag){
                            console.log('yesss')
                            buyerOfferPrice = product.buyerOfferPrice
                            if(enquiryInfo[0].country == 'USA'){
                                percentageVal = Number(buyerOfferPrice-oceanFreightPrLb)*Number(percentageSum/100)
                            console.log(percentageVal,'percentageVal')
                            console.log(percentageSum,'percentageSum')
                            console.log(costOfSaleUSBVal,'costOfSaleUSBVal')
                            console.log(percentageVal)
                            totCostOfSalesPerLBUSD = Number((costOfSalesPerLBUSD+percentageVal).toFixed(2))
                        }
                        //cost of sales consideration based on UOM price
                        if(product.priceUOM == 2){
                            netProfitLoss = Number((Number(buyerOfferPrice)-Number(totCostOfSalesPerLBUSD)).toFixed(2))
                        }else{
                            netProfitLoss = Number((Number(buyerOfferPrice)-Number(costOfSalesPerKgUSD)).toFixed(2))
                        }
                        console.log(buyerOfferPrice,'bb')
                        console.log(totCostOfSalesPerLBUSD,'tt')
                        console.log(netProfitLoss,'nl')

                        }
                        if(buyerOfferPriceFlag){
                            console.log('nooo')
                            buyerOfferPrice = buyerPriceDataMap.get(product.variantId).buyerOfferPrice
                            netProfitLoss = (((buyerPriceDataMap.get(product.variantId)).netPLOnBuyerPrice))
                            totalProfitLoss = buyerPriceDataMap.get(product.variantId).totalProfitLoss
                            plPercentage = buyerPriceDataMap.get(product.variantId).plPercentage
                            contributionPercentage = buyerPriceDataMap.get(product.variantId).contributionPercentage
                            percentageVal = Number(buyerOfferPrice-oceanFreightPrLb)*Number(percentageSum/100)
                            totCostOfSalesPerLBUSD =Number((costOfSalesPerLBUSD+percentageVal).toFixed(2))
                        }
                        console.log(costOfSalesPerLBUSD,'costOfSalesPerLBUSDnnn')
                        //prevailing Market Rate
                        const prevailingMarketRate = ProductPriceInfoMap.get(product.variantId)!=undefined?ProductPriceInfoMap.get(product.variantId):0
                        //previous confirmed price 
                        if(sameBuyerEnquiryFlag){
                            if(sameBuyerEnquiriesMap.get(product.variantId)){
                                prevConfirmedPrice = Number(Number(sameBuyerEnquiriesMap.get(product.variantId)).toFixed(2))
                            }else{
                                if(prevenquiriesFlag){
                                    prevConfirmedPrice = prevEnquiryDataMap.get(product.variantId) ? Number(parseFloat(String(prevEnquiryDataMap.get(product.variantId))).toFixed(2)) : 0
                                }
                            }
                        }else{
                            if(prevenquiriesFlag){
                                prevConfirmedPrice =  prevEnquiryDataMap.get(product.variantId) ? Number(parseFloat(String(prevEnquiryDataMap.get(product.variantId))).toFixed(2)) : 0
                            }
                        }
                        const productName = product.variant +'/' + product.packStyle
                        const productObj = new productRates(product.variantId,product.shrimpQty,productName,product.leadType,yieldVal,packCount,rmCount,rmRate,rmCost,mfgCost,saleCommPer,saleCommission,packmaterailCost,freightAndForwardExp,totalExpenses,productionCost,fixedCost,costOfSalesPerKgINR,costOfSalesPerKgUSD,costOfSalesPerLBUSD,quotePrice,buyerOfferPrice,netProfitLoss,incentives,totalProfitLoss,plPercentage,contributionPercentage,prevConfirmedPrice,prevailingMarketRate,addedPriceToRmrate,reducedPriceToRmRate,saleCostToAddedRmrate,saleCostToReducedRmrate,product.styleWeighment,product.category,frozenyield,enquiryInfo[0].country == 'USA'?Number(percentageVal.toFixed(2)):0,totCostOfSalesPerLBUSD,product.group,product.cartons,product.containers,product.enquiryProductId,product.netWeight)
                        productObj.peelingRate = Number(peelingCost)
                        productObj.priceUOM = product.priceUOM
                        productObj.qtyUOM = product.uomId
                        productPricesData.push(productObj)
                    }
                    const resData = new CostSheetModel(enquiryInfo[0].buyer,enquiryInfo[0].agent,enquiryInfo[0].country,enquiryInfo[0].destination,enquiryInfo[0].shipTerms,oceanFreightInUsd,enquiryInfo[0].shipmentPeriod,enquiryInfo[0].noOfContainers,enquiryInfo[0].enquiryDate,datesInfo[0].assesmentApprovalDate,datesInfo[0].QuoteSentDate,datesInfo[0].Accepteddate,exchangeRate[0].exchangeRate,enquiryInfo[0].enquiryStatus,productPricesData,enquiryInfo[0].country == 'USA'?adPer:0,enquiryInfo[0].country == 'USA'?cvdPer:0,enquiryInfo[0].enquiryNumber)
                    //saving cost sheet data 
                    //mfg details 

                    const mfgData = await transmanager.getCustomRepository(CostSheetRepo).getFixedPriceInfo()
                    //to save freight charges,those should fetch from global prices 
                    const freightChargesData = await transmanager.getCustomRepository(CostSheetRepo).getGlobalPriceInfo()
                    const saveData = await this.saveCostSheetDetails(resData,req.enquiryid,mfgData,freightChargesData,ocaenFreightPerKg,transmanager)
                    if(saveData ==true){
                        const updateEnquiryStatus = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryid},{lifeCycleStatus:EnquiryLifecycleStatusEnum.COSTING_APPROVED})
                        if(updateEnquiryStatus.affected){
                            await transmanager.completeTransaction()
                            const costSheetInfo = await this.costSheetRepo.getCostSheetInfo(req.enquiryid)
                            console.log(costSheetInfo,'lllllll')
                            resData.productRates = costSheetInfo
                            return new CostingSheetResponse(true,1,'Cost Sheet data retreived',[resData])
                        }else{
                            await transmanager.releaseTransaction()
                            return new CostingSheetResponse(false,0,'Something went wrong in updating enquiry lifecycle status')
                        }
                        // const getCostInfo = await this.getCostSheetInfo(new EnquiryIdreq(req.enquiryid))
                    }else{
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Something went wrong in cost sheet generation')
                    }
                }else{
                     await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'No exchange rate found for selected enquiry')
                }
        
            }else{
                await transmanager.releaseTransaction()
                return new CostingSheetResponse(false,0,'no enquiry found')
            }

        }else{
            console.log('**************************************')
            const costsheetdata = await this.getCostSheetInfo(new EnquiryIdreq(req.enquiryid))
            if(costsheetdata.status){
                await transmanager.completeTransaction()
                return new CostingSheetResponse(true,100,'Already Cost Sheet Generated',costsheetdata.data)
            }else{
                await transmanager.releaseTransaction()
                return costsheetdata
            }

        }
        
    }

    async getCostSheetInfo(req:EnquiryIdreq):Promise<CostingSheetResponse>{
        const costSheetInfo = await this.costSheetRepo.getCostSheetInfo(req.enquiryid)
        const enquiryInfo = await this.enquiryRepo.getEnquiryDetailsForCostSheet(req.enquiryid)
        const datesInfo = await this.enquiryRepo.getEnquiryStatusInfo(req.enquiryid)
        const exchangeRate = await this.getExchangeRate(req.enquiryid,enquiryInfo[0].currencyId)
        const oceanFrieghtRate = await this.getOcenFrightOfEnquiry(enquiryInfo[0].countryId,enquiryInfo[0].destinationId)
        console.log(oceanFrieghtRate,'oceanFrieghtRate')
        const oceanFreightInUsd = enquiryInfo[0].isFOB == 0  ? 0 : oceanFrieghtRate[0].oceanFreightRateUSD

        if(enquiryInfo.length > 0){
            const resData = new CostSheetModel(enquiryInfo[0].buyer,enquiryInfo[0].agent,enquiryInfo[0].country,enquiryInfo[0].destination,enquiryInfo[0].shipTerms,oceanFreightInUsd,enquiryInfo[0].shipmentPeriod,enquiryInfo[0].noOfContainers,enquiryInfo[0].enquiryDate,datesInfo[0].assesmentApprovalDate,datesInfo[0].QuoteSentDate,datesInfo[0].Accepteddate,exchangeRate[0].exchangeRate,enquiryInfo[0].enquiryStatus,costSheetInfo,costSheetInfo[0].ad,costSheetInfo[0].cvd,enquiryInfo[0].enquiryNumber)
            return new CostingSheetResponse(true,1,'Data Retrived',[resData])
        }else{
            return new CostingSheetResponse(false,0,'No data Found for selected Enquiry')
        }

    }
    async saveCostSheetDetails(req:CostSheetModel,enquiryId:number,mfgData:any,freightChargesData:any,oceanFreight:number,transmanager){
        // const transmanager = new GenericTransactionManager();

        // const manager = new Transtrab
        // await transmanager.startTransaction()
        let saveFlag = new Set<boolean>()
        for(const record of req.productRates){
            console.log(record,'hhhhh')
        const costSheetObj = new CostSheetEntity()
            costSheetObj.addedRmRate = record.addedPriceToRmrate
            costSheetObj.buyerOfferPrice = record.buyerOfferPrice
            costSheetObj.contributionPercentage = record.contributionPercentage
            costSheetObj.costOfSalesInr = record.costOfSalesPerKgINR
            costSheetObj.costOfSalesUSDKG = record.costOfSalesPerKgUSD
            costSheetObj.costOfSalesUSDLB = record.costOfSalesPerLBUSD
            costSheetObj.enquiryEntity = new EnquiriesEntity()
            costSheetObj.enquiryEntity.enquiryId = enquiryId
            costSheetObj.enquiryProductEntity = new EnquiryProdctsEntity()
            costSheetObj.enquiryProductEntity.enquiryProductId = record.enquiryProductId
            costSheetObj.exchangeRate = req.exchangeRate
            costSheetObj.finalProfitLoss = record.totalProfitLoss
            costSheetObj.freightAndForwardExp = record.freightAndForwardExpenses
            costSheetObj.incentives = record.incentives
            costSheetObj.mfgCost = record.manufacturingCost
            costSheetObj.netPlOnBuyerPrice = record.netPLOnBuyerPrice
            costSheetObj.packCount = record.packCount
            costSheetObj.packMaterialCost = record.packingMaterial
            costSheetObj.plPercentage = record.plPercentage
            costSheetObj.prevConfirmedPrice = record.prevConfirmedPrice
            costSheetObj.quantity = record.quantity
            costSheetObj.quotePrice = record.quotePrice
            costSheetObj.quoteStatus = record.quotePrice >0 ? true : false
            costSheetObj.reducedRmRate = record.reducedPriceToRmRate
            costSheetObj.rmCost = record.rmCost
            costSheetObj.rmCount = record.rmCount
            costSheetObj.rmRate = record.prevailingRmRate
            costSheetObj.salesCommissionPercentage = record.salesCommissionpercentage
            costSheetObj.saleCommission = record.salesCommission
            costSheetObj.saleCostAddedRmrate = record.costOfSalesForAddedRmRate
            costSheetObj.saleCostReducedRmrate = record.costOfSalesForReducedRmRate
            costSheetObj.totalExpenses = record.totalExpenses
            costSheetObj.variantId = record.productId
            costSheetObj.yield = record.yieldPer
            costSheetObj.frozenYield = record.frozenYield
            costSheetObj.productionCost = record.costOfProduction
            costSheetObj.fixedCost = record.fixedCost
            costSheetObj.marketRate = record.prevailingMarketRate
            costSheetObj.adCvdPerValue = record.adCVDpercentageVal
            costSheetObj.totalSaleCost = record.totCostOfSalesPerLBUSD
            costSheetObj.adPercentage = req.ad
            costSheetObj.cvdPercentage = req.cvd
            costSheetObj.noOfContainers = record.containers
            const save = await transmanager.getCustomRepository(CostSheetRepo).save(costSheetObj)
            if(save){
                saveFlag.add(true)
                const mfgCostsheetObj = new MFGCostsEntity()
                mfgCostsheetObj.adminAndOtherCost = mfgData[0].procuremnetFreight
                mfgCostsheetObj.boilerFuelCost = mfgData[0].boilerFuelCost
                mfgCostsheetObj.consumableCost = mfgData[0].consumableCost
                mfgCostsheetObj.deheadingCost = mfgData[0].deheadingCost
                mfgCostsheetObj.depreciation = mfgData[0].depreciation
                mfgCostsheetObj.electricityCost = mfgData[0].electricityCost
                mfgCostsheetObj.enquiryEntity = new EnquiriesEntity()
                mfgCostsheetObj.enquiryEntity.enquiryId = enquiryId
                mfgCostsheetObj.enquiryProducts = new EnquiryProdctsEntity()
                mfgCostsheetObj.enquiryProducts.enquiryProductId = record.enquiryProductId
                mfgCostsheetObj.financeCost = mfgData[0].financeCost
                mfgCostsheetObj.inhouseLabourCost = mfgData[0].inhouseLabourCost
                mfgCostsheetObj.otherDirectExpences = mfgData[0].otherDirectExpenses
                mfgCostsheetObj.procurementFrieght = mfgData[0].procuremnetFreight
                mfgCostsheetObj.peelingCost = record.peelingRate//uncomm
                mfgCostsheetObj.qcCost = mfgData[0].qcCost
                mfgCostsheetObj.repairsAndMaintainance = mfgData[0].maintainanceCost
                mfgCostsheetObj.soakingCost = mfgData[0].soakingCost
                mfgCostsheetObj.salariesAndRemunarations = mfgData[0].salariesAndRemunarations
                mfgCostsheetObj.variantId = record.productId
                const mfgCostsSave = await transmanager.getRepository(MFGCostsEntity).save(mfgCostsheetObj)
                if(mfgCostsSave){
                    saveFlag.add(true)
                    //freight charges saving
                    const freightChagesObj = new FreightForwardExpensesEntity()
                    freightChagesObj.EIACharges = freightChargesData[0].eiaCharges
                    freightChagesObj.agriMarketingCess = freightChargesData[0].marketingCess
                    freightChagesObj.antiDumpingDuty = freightChargesData[0].antiDumpingDuty
                    freightChagesObj.clearingAndForwardingCharges = freightChargesData[0].forwardingCharges
                    freightChagesObj.enquiryEntity = new EnquiriesEntity()
                    freightChagesObj.enquiryEntity.enquiryId = enquiryId
                    freightChagesObj.localFreightCharges = freightChargesData[0].localFreight
                    freightChagesObj.marineInsurance = freightChargesData[0].marineInsurance
                    freightChagesObj.oceanFreight = oceanFreight
                    freightChagesObj.otherExpenses = freightChargesData[0].otherExp
                    freightChagesObj.surveyExpenses = freightChargesData[0].surveyExpenses
                    freightChagesObj.variantId = record.productId
                    const freightChargesSave = await transmanager.getRepository(FreightForwardExpensesEntity).save(freightChagesObj)
                    if(freightChargesSave){
                        saveFlag.add(true)
                    }else{
                        saveFlag.add(false)
                        break
                    }
                }else{
                    saveFlag.add(false)
                    break
                }
            }else{
                saveFlag.add(false)
                break
            }
        }
        if(!(saveFlag.has(false))){
            // await transmanager.completeTransaction()
            return true
        }else{
            await transmanager.releaseTransaction()
            return false
        }
    }
    async UpdateEnquiry(req:QuoteRequest):Promise<CommonResponse>{
        const transmanager = new GenericTransactionManager();
        try{
            // const exists = await this.costSheetRepo.find({enquiryEntity:{enquiryId:req.enquiryId}})
            // if(exists){
            await transmanager.startTransaction()
            let saveFlag = new Set<boolean>()
                let enquiryNo 
            for(const res of req.productPrices){
                console.log(req.productPrices)
                const validate = await transmanager.getRepository(CostSheetEntity).findOne({where:{enquiryProductEntity:{enquiryProductId:res.enquiryProductId}},relations:['enquiryEntity']})
                console.log(validate,'lllllll')
                if(validate){
                    const entity = new CostSheetEntity()
                    entity.finalProfitLoss = res.totalPL? res.totalPL:validate.finalProfitLoss
                    entity.plPercentage = res.plPercentage? res.plPercentage:validate.plPercentage
                    entity.contributionPercentage = res.contributionPercentage? res.contributionPercentage:validate.contributionPercentage

                    entity.quotePrice = res.quotePrice
                    entity.quoteStatus = true
                    entity.saleCostAddedRmrate = res.costOfSalesForAddedRmRate
                    entity.saleCostReducedRmrate = res.costOfSalesForReducedRmRate
                    entity.addedRmRate = req.addedPriceToRmrate
                    entity.reducedRmRate = req.reducedPriceToRmRate
                    entity.incentives = res.incentives
                    entity.adCvdPerValue = res.adCvdPercent
                    entity.totalSaleCost = res.totalCostOfSalesPerLb
                    // entity.costSheetId = validate.costSheetId
                    const updated = await transmanager.getRepository(CostSheetEntity).update({costSheetId:validate.costSheetId},entity)
                    // const updated = await transmanager.getRepository(CostSheetEntity).save(entity)
                    if(updated){
                        saveFlag.add(true)
                    }else{
                        saveFlag.add(false)
                        await transmanager.releaseTransaction()
                        return new CommonResponse(false,0,'Something went wrong in updating quote price')
                    }
                    // const updated = await this.costSheetRepo.update({variantId:res.productId,enquiryEntity:{enquiryId:req.enquiryId}},{quotePrice:res.quotePrice,quoteStatus:true,saleCostAddedRmrate:res.costOfSalesForAddedRmRate,incentives:res.incentives,saleCostReducedRmrate:res.costOfSalesForReducedRmRate,addedRmRate:req.addedPriceToRmrate,reducedRmRate:req.reducedPriceToRmRate})
                }else{
                    saveFlag.add(false)
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false,0,'No record found with that enquiry and product')
                }
                // recordsUpdated = true;
                enquiryNo = validate.enquiryEntity.enquiryNumber
                // if(recordsUpdated){
                //     saveFlag.add(true)
                // }else{
                //     saveFlag.add(false)
                //     break
                // }
            }
            if(!(saveFlag.has(false))){
                const log = new EnquiryLogEntity()
                log.enquiryEntity = new EnquiriesEntity()
                log.enquiryEntity.enquiryId = req.enquiryId
                log.enquiryNumber = enquiryNo
                log.enquiryStatus = req.leadStatus
                const enquiryLogSave = await transmanager.getRepository(EnquiryLogEntity).save(log)
                if(!enquiryLogSave){
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false,0,'Soemthign went wrong in updating enquiry log')
                }
                const updateEnquiryStatus = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryId},{lifeCycleStatus:req.leadStatus})
                if(updateEnquiryStatus.affected){
                    await transmanager.completeTransaction()
                    return new CommonResponse(true,1,'Data updated successfully')
                }else{
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false,0,'Soemthing went wrong in enquiry status update')
                }
            }else{
                await transmanager.releaseTransaction()
                return new CommonResponse(true,1,'Something went wrong in updating quote price')
            }
        }catch(err){
            await transmanager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong')
        }
        
    }
    async UpdateBuyerWisePrices(req:QuoteRequest):Promise<CommonResponse>{
        const transmanager = new GenericTransactionManager();
        try{
            await transmanager.startTransaction()
            let saveFlag = new Set<boolean>()
            // const exists = await this.costSheetRepo.find({enquiryEntity:{enquiryId:req.enquiryId}})
            // if(exists){
            let enquiryNo 
            for(const res of req.productPrices){
                // const validate = await transmanager.getRepository(CostSheetEntity).findOne({where:{variantId:res.productId, enquiryEntity:{enquiryId:req.enquiryId}},relations:['enquiryEntity']})
                const validate = await transmanager.getRepository(CostSheetEntity).findOne({where:{enquiryProductEntity:{enquiryProductId:res.enquiryProductId}},relations:['enquiryEntity']})
                if(validate){
                    // const entity = new CostSheetEntity()
                    // entity.netPlOnBuyerPrice = res.netPLOnBuyerPrice
                    // entity.contributionPercentage = res.contributionPercentage
                    // entity.buyerOfferPrice = res.buyerPrice
                    // entity.finalProfitLoss = res.totalPL
                    // entity.plPercentage = res.plPercentage
                    // entity.adCvdPerValue = res.adCvdPercent
                    // entity.totalSaleCost = res.totalCostOfSalesPerLb
                    // const updated = await transmanager.getRepository(CostSheetEntity).update({variantId:res.productId,enquiryEntity:{enquiryId:req.enquiryId}},{netPlOnBuyerPrice:res.netPLOnBuyerPrice,buyerOfferPrice:res.buyerPrice,plPercentage:res.plPercentage,finalProfitLoss:res.totalPL,contributionPercentage:res.contributionPercentage,adCvdPerValue:res.adCvdPercent,totalSaleCost:res.totalCostOfSalesPerLb})
                    const updated = await transmanager.getRepository(CostSheetEntity).update({enquiryProductEntity:{enquiryProductId:res.enquiryProductId}},{netPlOnBuyerPrice:res.netPLOnBuyerPrice,buyerOfferPrice:res.buyerPrice,plPercentage:res.plPercentage,finalProfitLoss:res.totalPL,contributionPercentage:res.contributionPercentage,adCvdPerValue:res.adCvdPercent,totalSaleCost:res.totalCostOfSalesPerLb})
                    if(updated.affected){
                        saveFlag.add(true)
                    }else{
                        saveFlag.add(false)
                        await transmanager.releaseTransaction()
                        return new CommonResponse(false,0,'Somethign went wrong in updating buyer price')
                    }
                    enquiryNo = validate.enquiryEntity.enquiryNumber
                }else{
                    saveFlag.add(false)
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false,0,'No record found with the enquiry and product')
                }  
            } 
            if(!(saveFlag.has(false))){
                const log = new EnquiryLogEntity()
                log.enquiryEntity = new EnquiriesEntity()
                log.enquiryEntity.enquiryId = req.enquiryId
                log.enquiryNumber = enquiryNo
                log.enquiryStatus = req.leadStatus
                
                const enquiryLogSave = await transmanager.getRepository(EnquiryLogEntity).save(log)
                if(!enquiryLogSave){
                    await transmanager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in saving enquiry log')
                }else{
                    const enquiryUpdate = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryId},{lifeCycleStatus:req.leadStatus})
                    if(enquiryUpdate){
                        await transmanager.completeTransaction()
                        return new CommonResponse(true,1,'Buyer Price updated Successfully')
                    }else{
                        await transmanager.releaseTransaction()
                        return new CommonResponse(false,0,'Somethign went wrong in updating enquiry status')
                    }
                }
                
            }else{
                await transmanager.releaseTransaction()
                return new CommonResponse(false,0,'Somethign went wrong')
            }
        }catch(err){
            await transmanager.releaseTransaction()
            return new CommonResponse(false, 0,'something went wrong')
        }
        
    }
    async UpdateCostingApproval(req:EnquiryAssessmentUpdateReq):Promise<CommonResponse>{
        try{
              const enquiry = await this.enquiriesRepo.findOne({enquiryId:req.id})
              
              if(enquiry){
                let update
                if(req.status === EnquiryLifecycleStatusEnum.REJECTED){
                update = await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,enquiryRejectReason:req.rejectReason,updatedUser:req.createdUser,enquiryRejectDescription:req.rejectDescription})
                }
                if(req.status === EnquiryLifecycleStatusEnum.ACCEPTED){
                  update=  await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,freezeStatus:true,updatedUser:req.createdUser})
                }
                if(req.status != undefined){
                    update=  await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,updatedUser:req.createdUser})
                  }
                if(update.affected){
                    const log = new EnquiryLogEntity()
                        log.enquiryEntity = new EnquiriesEntity()
                        log.enquiryEntity.enquiryId = req.id
                        log.enquiryNumber = enquiry.enquiryNumber
                        log.enquiryStatus = req.status                        
                        await this.enquiryLogRepo.save(log)
                }
              }
            return new CommonResponse(true, 1,'Data Updated successfully')

        }catch(err){
            throw(err)
        }
        
    }

    async getEnquiryDestinations (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.destination_id AS destinationId,d.destination_name AS destination
            FROM ${appSettings.enquiry_db}.enquiries e
            LEFT JOIN ${appSettings.masters_db}.destination d ON d.destination_id = e.destination_id
            WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and e.life_cycle_status ='${req.tabName}' and d.destination_name is not null`
            }
            query = query + ` GROUP BY d.destination_name ORDER BY d.destination_name`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getEnquiryUnits (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.unit_id,u.unit_name AS unitName
            FROM ${appSettings.enquiry_db}.enquiries e
            LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = e.unit_id
            WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and e.life_cycle_status ='${req.tabName}' and u.unit_name is not null`
            }
            query = query + ` GROUP BY u.unit_name ORDER BY u.unit_name`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async updateConfirmedContainers(req: ContainersReq): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {
        await manager.startTransaction();
        for (const rec of req.confirmedContainersInfo) {
            if (rec.confirmedContainers === null ||rec.confirmedContainers === undefined) {
                await manager.releaseTransaction();
                return new CommonResponse(false,0,`Invalid confirmedContainers value for enquiryProductId ${rec.enquiryProductId}`);
            }
        }

        let saveFlag = new Set<boolean>();
        for (const rec of req.confirmedContainersInfo) {
            const updateContainers = await manager.getRepository(EnquiryProdctsEntity).update(
                    { enquiryProductId: rec.enquiryProductId },
                    { confirmedContainers: rec.confirmedContainers }
                );

            if (!updateContainers.affected) {
                saveFlag.add(false);
                await manager.releaseTransaction();
                return new CommonResponse(false,0,"Something went wrong in confirmed containers updation");
            }
        }

        if (!saveFlag.has(false)) {
            const enqReq = new EnquiryAssessmentUpdateReq(
                req.enquiryId,
                EnquiryLifecycleStatusEnum.ACCEPTED,
                null,
                req.createdUser
            );
            const updateEnquiryStatus = await this.UpdateCostingApproval(enqReq);
            if (updateEnquiryStatus.status) {
                await manager.completeTransaction();
                return new CommonResponse(true, 1, "Approved Successfully");
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(
                    false,
                    0,
                    "Something went wrong in enquiry status updation"
                );
            }
        }
    } catch (err) {
        console.log(err, "====");
        await manager.releaseTransaction();
        return new CommonResponse(false, 0, "Something went wrong");
    }
}


    // async updateConfirmedContainers(req:ContainersReq):Promise<CommonResponse>{
    //     const manager = new GenericTransactionManager()
    //     try{
    //         await manager.startTransaction()
    //         let saveFlag = new Set<boolean>()
    //         for(const rec of req.confirmedContainersInfo){
    //             const updateContainers = await manager.getRepository(EnquiryProdctsEntity).update({enquiryProductId:rec.enquiryProductId},{confirmedContainers:rec.confirmedContainers})
    //             if(!(updateContainers.affected)){
    //                 saveFlag.add(false)
    //                 await manager.releaseTransaction()
    //                 return new CommonResponse(false,0,'Something went wrong in confirmed containers updation')
    //             }
    //         }
    //         if(!(saveFlag.has(false))){
    //             const enqReq = new EnquiryAssessmentUpdateReq(req.enquiryId,EnquiryLifecycleStatusEnum.ACCEPTED,null,req.createdUser)
    //             const updateEnquiryStatus = await this.UpdateCostingApproval(enqReq)
    //             if(updateEnquiryStatus.status){
    //                 await manager.completeTransaction()
    //                 return new CommonResponse(true,1,'Approved Successfully')
    //             }else{
    //                 await manager.releaseTransaction()
    //                 return new CommonResponse(false,0,'Something went wrong in enquiry status updation')
    //             }
    //         }
    //     }catch(err){
    //         console.log(err,'====')
    //         await manager.releaseTransaction()
    //         return new CommonResponse(false,0,'Something went wrong')

    //     }
    // }

    async getDestinationsForCostSheet():Promise<CommonResponse>{
        const manager = getManager()
        let query=`SELECT d.destination_id AS destinationId,d.country_id AS countryId,d.destination_name AS destinationName,c.country_name AS countryName
        FROM ${appSettings.masters_db}.destination d
        LEFT JOIN ${appSettings.masters_db}.countries c ON c.country_id=d.country_id`
        const data=await manager.query(query)
        if(data.length > 0){
            return new CommonResponse(true,1,'Data retrieved successfully',data)
        }else{
            return new CommonResponse(false,0,'No data found',[])
        }
    }

    async generateCostSheetAgainstDestination(req:CostingDestinationReq):Promise<CostingSheetResponse>{
        //get basic details of an enqiry
        const manager=getManager()
        const transmanager = new GenericTransactionManager();
        await transmanager.startTransaction()
            const costsheetdata = await this.getCostSheetInfoForDestination(new CostingDestinationReq(req.enquiryid,req.destinationId))
            if(costsheetdata.status){
                await transmanager.completeTransaction()
                return new CostingSheetResponse(true,100,'Destination Comparision CostSheet Generated',costsheetdata.data)
            }else{
                await transmanager.releaseTransaction()
                return costsheetdata
            }
        
    }

    async getCostSheetInfoForDestination(req: CostingDestinationReq): Promise<CostingSheetResponse> {
        const manager=getManager()
        const transmanager = new GenericTransactionManager();
        await transmanager.startTransaction()
        const enquiryInfoData = await this.enquiryRepo.getEnquiryDetailsForCostSheet(req.enquiryid);

        if (!enquiryInfoData || enquiryInfoData.length === 0) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'No enquiry found');
        }
    
        const datesInfo = await this.enquiryRepo.getEnquiryStatusInfo(req.enquiryid);
        if (!datesInfo || datesInfo.length === 0) {
            // Handle missing datesInfo, perhaps not critical enough for full stop
            // console.warn('DatesInfo not found for enquiry:', req.enquiryid);
        }
    
    
        const exchangeRate = await this.getExchangeRate(req.enquiryid, enquiryInfoData[0].currencyId);
        if (!exchangeRate || exchangeRate.length === 0 || !exchangeRate[0]) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'No exchange rate found for selected enquiry');
        }
    
        const oceanFrieghtRate = await this.getOcenFrightOfEnquiry(null, req.destinationId);
        console.log(oceanFrieghtRate,"!!!!!!!!!!!!!!!!!!!!!")
        // Conditional check for ocean freight rate based on FOB status
        const isFOB = enquiryInfoData[0].isFOB === 0;
        const oceanFreightRateUSD = oceanFrieghtRate && oceanFrieghtRate?.length > 0 && oceanFrieghtRate[0] ? oceanFrieghtRate[0]?.oceanFreightRateUSD : null;
    
        if (!isFOB && oceanFreightRateUSD == null) { // only throw error if not FOB and rate is missing
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'No Ocean freight rate found for selected enquiry (non-FOB)');
        }
    
        const finalOceanFreightInUsd = isFOB ? 0 : oceanFreightRateUSD;
    
        const enquiryProducts = await this.enquiryProductsRepo.getEnquiryProductsForEnquiry(req.enquiryid);
        if (!enquiryProducts || enquiryProducts.length === 0) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false,0,'No products found for this enquiry');
        }
    
        const containerProductsMap = new Map<number, number>();
        let groupQty = 0;
        for (const productitem of enquiryProducts) {
            const uomInfo = UnitsOfWeightInput.find(item => item.value == productitem.uomId);
            if (uomInfo) {
                if (uomInfo.name == 'lb') {
                    groupQty = (productitem.shrimpQty) * 0.454;
                } else if (uomInfo.name == 'oz') {
                    groupQty = ((productitem.shrimpQty) / 16) * 0.454;
                } else if (uomInfo.name == 'gm') {
                    groupQty = (productitem.shrimpQty) / 1000;
                } else { // Assuming kg or other direct measures
                    groupQty = productitem.shrimpQty;
                }
            } else {
                 // Default or error if UOM not recognized
                groupQty = productitem.shrimpQty;
            }
    
    
            if (containerProductsMap.has(productitem.group)) {
                const prevQty = containerProductsMap.get(productitem.group) || 0;
                containerProductsMap.set(productitem.group, (Number(prevQty) + Number(groupQty)));
            } else {
                containerProductsMap.set(productitem.group, Number(groupQty));
            }
        }
    
        const variantIdsQry = `select group_concat(distinct(variant_id)) as variantId from ${appSettings.enquiry_db}.enquiry_products where enquiry_id = ${req.enquiryid} `;
        const variantData = await manager.query(variantIdsQry);
    
        if (!variantData || variantData.length === 0 || !variantData[0] || !variantData[0].variantId) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'No variant IDs found for enquiry products');
        }
        const distinctVariantIds = variantData[0].variantId;
    
        const yieldPerQry = `SELECT sku_code_id as variantId,loss_or_gain_percentage as yieldper,food_type_id as foodTypeId,value_addition_one_id as valoneId,value_addition_two_id as valtwoId,value_addition_three_id as valthreeId,grades.grade_min_count as minGrade,grade_max_count as maxGrade FROM ${appSettings.masters_db}.sku_codes 
        left join ${appSettings.masters_db}.grades on grades.grade_id = sku_codes.grade_id
        WHERE sku_code_id in (${distinctVariantIds})`;
        const yieldData = await manager.query(yieldPerQry);
    
        if (!(yieldData.length > 0)) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'Yield percentage not found');
        }
    
        const yieldPerMap = new Map<number, number>();
        let foodTypes: number[] = [];
        let valAddOnes: number[] = [];
        let valAddTwos: number[] = [];
        let valAddThrees: number[] = [];
        let minGrades: number[] = [];
        let maxGrades: number[] = [];
    
        yieldData.forEach(rec => {
            if (Number(rec.yieldper) <= 0) {
                // This error might be too broad if only one product has zero yield.
                // Consider collecting errors or being more specific.
                // For now, following original logic to return an error if any yield is zero.
                // This could also be checked later per product.
                // throw new Error('Yield percentage should not be zero for all products'); // Or return CostingSheetResponse
            }
            if (!yieldPerMap.has(rec.variantId)) {
                yieldPerMap.set(rec.variantId, rec.yieldper);
            }
            if (rec.valoneId != null && !valAddOnes.includes(rec.valoneId)) {
                valAddOnes.push(rec.valoneId);
            }
            if (rec.valtwoId != null && !valAddTwos.includes(rec.valtwoId)) {
                valAddTwos.push(rec.valtwoId);
            }
            if (rec.valthreeId != null && !valAddThrees.includes(rec.valthreeId)) {
                valAddThrees.push(rec.valthreeId);
            }
            if (rec.minGrade != null && !minGrades.includes(rec.minGrade)) {
                minGrades.push(rec.minGrade);
            }
            if (rec.maxGrade != null && !maxGrades.includes(rec.maxGrade)) {
                maxGrades.push(rec.maxGrade);
            }
            if (rec.foodTypeId != null && !foodTypes.includes(rec.foodTypeId)) { // Corrected from foodType
                foodTypes.push(rec.foodTypeId);
            }
        });
        
        // Check for any zero yield; original code had a separate loop for this.
        // Consolidating it here for efficiency or it can be checked when `yieldVal` is retrieved.
        for (const rec of yieldData) {
            if (Number(rec.yieldper) <= 0) {
                if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                    await transmanager.releaseTransaction();
                }
                return new CostingSheetResponse(false, 0, `Yield percentage is zero or invalid for variantId ${rec.variantId}`);
            }
        }
    
    
        const rmratesMap = new Map<number, number>();
        const rmratesQry = `SELECT COUNT as count,price FROM ${appSettings.rm_procure_db}.rm_rates where category = '${CompanyCategoryEnum.OWN}' and type = '${HarvestTypes.Re_Weighment}'`;
        const rmratesData = await manager.query(rmratesQry);
        if (!(rmratesData.length > 0)) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'RM rates not found');
        }
        rmratesData.forEach(element => {
            if (!(rmratesMap.has(element.count))) {
                rmratesMap.set(Number(element.count), element.price);
            }
        });
    
        const mfgRatesQry = `SELECT sum(price)AS mfgwithBoilerCost,packing_category as packCategory,SUM(CASE WHEN component = 'Boiler Fuel Cost' THEN 0 ELSE price END) AS mfgCostWithoutBoilerFuel FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG' group by packing_category`;
        const mfgRatesData = await manager.query(mfgRatesQry);
        if (!(mfgRatesData.length > 0)) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'MFG component rates not found');
        }
        const mfgRatesMap = new Map<string, { withBoilerCost: number, withoutBoilerCost: number }>();
        for (const rec of mfgRatesData) {
            if (!(mfgRatesMap.has(rec.packCategory))) {
                mfgRatesMap.set(rec.packCategory, { withBoilerCost: rec.mfgwithBoilerCost, withoutBoilerCost: rec.mfgCostWithoutBoilerFuel });
            }
        }
    
        const peelingrateMap = new Map<string, string>(); // Assuming price is string, convert to Number when using
        // Ensure arrays for IN clauses are not empty to prevent SQL errors. Use '0' or other non-matching placeholder.
        const pellingInfoQry = `SELECT min_grade as minGrade,max_grade as maxGrade,rate_per_kg as price,food_type_id as foodTypeId,value_add_1 as valoneId,value_add_2 as valtwoId,value_add_3 as valthreeId  FROM ${appSettings.masters_db}.deheading_peeling_chart WHERE 
        min_grade IN(${minGrades.length ? minGrades.join(',') : "'0'"}) AND 
        max_grade IN(${maxGrades.length ? maxGrades.join(',') : "'0'"}) AND 
        food_type_id IN(${foodTypes.length ? foodTypes.join(',') : "'0'"}) AND 
        value_add_1 IN(${valAddOnes.length ? valAddOnes.join(',') : "'0'"}) AND 
        value_add_2 IN(${valAddTwos.length ? valAddTwos.join(',') : "'0'"}) AND 
        value_add_3 IN(${valAddThrees.length ? valAddThrees.join(',') : "'0'"})`;
        const peelingRatesInfo = await manager.query(pellingInfoQry);
    
        if (!(peelingRatesInfo.length > 0)) {
            // This might be acceptable if not all products require peeling or if peeling rates are optional.
            // Depending on business logic, this could be a warning or an error.
            // For now, following original logic of erroring out.
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'No Peeling Rates found for the combination of product attributes');
        }
        for (const peelingRatesRec of peelingRatesInfo) {
            const peelingPriceObj = {
                foodTypeId: peelingRatesRec.foodTypeId,
                valaddOneId: peelingRatesRec.valoneId,
                valaddTwoId: peelingRatesRec.valtwoId,
                valaddThreeId: peelingRatesRec.valthreeId,
                minGrade: peelingRatesRec.minGrade,
                maxGrade: peelingRatesRec.maxGrade
            };
            const mapKey = JSON.stringify(peelingPriceObj);
            if (!peelingrateMap.has(mapKey)) {
                peelingrateMap.set(mapKey, peelingRatesRec.price);
            }
        }
    
        const globalPricesQry = `SELECT component,price,type FROM ${appSettings.masters_db}.global_price_chart`;
        const globalPricesData = await manager.query(globalPricesQry);
        if (!(globalPricesData.length > 0)) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'Global price rates not found');
        }
    
        const fixedRatesQry = `SELECT SUM(price) as fixedCost FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'Fixed'`;
        const fixedRatesData = await manager.query(fixedRatesQry);
        if (!(fixedRatesData.length > 0) || !fixedRatesData[0] || fixedRatesData[0].fixedCost == null) {
            if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                await transmanager.releaseTransaction();
            }
            return new CostingSheetResponse(false, 0, 'Fixed cost component rates not found or is null');
        }
        const enquiryFixedCost = Number(fixedRatesData[0].fixedCost);
        interface OfferPriceInfo {
            netPLOnBuyerPrice:number,
            totalProfitLoss:number,
            buyerOfferPrice:number,
            plPercentage:number,
            contributionPercentage:number,
        }
    
        const buyerPriceDataMap = new Map<number, OfferPriceInfo>();
        let buyerOfferPriceFlag: boolean = false;
        // Ensure CostSheetRepo is correctly typed and available, e.g. this.costSheetRepo
        const buyerOfferPriceData = await transmanager.getCustomRepository(CostSheetRepo).getBuyerOfferPriceOfEnquiry(req.enquiryid, distinctVariantIds, transmanager);
        if (buyerOfferPriceData.length > 0) {
            buyerOfferPriceFlag = true;
            buyerOfferPriceData.forEach(priceItem => {
                if (!(buyerPriceDataMap.has(priceItem.variantId))) {
                    buyerPriceDataMap.set(priceItem.variantId, {
                        netPLOnBuyerPrice: priceItem.netpl,
                        totalProfitLoss: priceItem.totalPl,
                        buyerOfferPrice: priceItem.buyerOfferPrice,
                        plPercentage: priceItem.plPercentage,
                        contributionPercentage: priceItem.contributionPercentage
                    });
                }
            });
        }
    
        const ProductPriceInfoMap = new Map<number, number>();
        const fgProductPriceQry = `SELECT product_id AS variantId,min_price as price FROM ${appSettings.masters_db}.product_price_list WHERE product_id IN(${distinctVariantIds}) and category = '${FgPriceListCategoryEnum.EXPORT}'`;
        const fgProductPriceData = await manager.query(fgProductPriceQry);
        fgProductPriceData.forEach(productPriceRec => {
            if (!(ProductPriceInfoMap.has(productPriceRec.variantId))) {
                ProductPriceInfoMap.set(productPriceRec.variantId, productPriceRec.price);
            }
        });
    
        const prevEnquiryDataMap = new Map<number, number>();
        const sameBuyerEnquiriesMap = new Map<number, number>();
        let prevenquiriesFlag: boolean = false;
        let sameBuyerEnquiryFlag: boolean = false;
    
        const prevConfirmedEnquiriesData = await this.enquiryRepo.getPrevConfirmedEnquiries(distinctVariantIds);
        const sameBuyerPrevEnquiryData = await this.enquiryRepo.getSameBuyerConfirmedEnquiries(distinctVariantIds, enquiryInfoData[0].buyerId);
    
        if (sameBuyerPrevEnquiryData.length > 0) {
            sameBuyerEnquiryFlag = true;
            sameBuyerPrevEnquiryData.forEach(record => {
                let unitPrice = record.unitPrice; // Ensure record.unitPrice is a number
                if ((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)) { // lb or oz
                    unitPrice = unitPrice / 0.454; // Convert to per kg if original is per lb
                }
                if ((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING)) {
                    if (record.uomId == 1 || record.uomId == 4) { // kg or gm
                         if (record.caseWeight && record.caseWeight !== 0) unitPrice = unitPrice / record.caseWeight;
                    } else if (record.uomId == 2 || record.uomId == 3) { // lb or oz
                         if (record.caseWeight && record.caseWeight !== 0) unitPrice = unitPrice / (0.454 * record.caseWeight);
                    }
                }
                // Ensure record.variantId is used as key
                if (record.variantId != null && !sameBuyerEnquiriesMap.has(record.variantId)) {
                    sameBuyerEnquiriesMap.set(record.variantId, unitPrice);
                }
            });
        }
        
        // Corrected Averaging Logic for prevConfirmedEnquiriesData
        if (prevConfirmedEnquiriesData.length > 0) {
            prevenquiriesFlag = true;
            const tempPriceSumMap = new Map<number, number>();
            const tempPriceCountMap = new Map<number, number>();
    
            prevConfirmedEnquiriesData.forEach(record => {
                let unitPrice = record.unitPrice;
                 if ((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)) {
                    unitPrice = unitPrice / 0.454;
                }
                if ((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING)) {
                     if (record.uomId == 1 || record.uomId == 4) {
                         if (record.caseWeight && record.caseWeight !== 0) unitPrice = unitPrice / record.caseWeight;
                    } else if (record.uomId == 2 || record.uomId == 3) {
                         if (record.caseWeight && record.caseWeight !== 0) unitPrice = unitPrice / (0.454 * record.caseWeight);
                    }
                }
    
                if (record.variantId != null) {
                    tempPriceSumMap.set(record.variantId, (tempPriceSumMap.get(record.variantId) || 0) + Number(unitPrice));
                    tempPriceCountMap.set(record.variantId, (tempPriceCountMap.get(record.variantId) || 0) + 1);
                }
            });
    
            tempPriceSumMap.forEach((sum, variantId) => {
                const count = tempPriceCountMap.get(variantId);
                if (count && count > 0) {
                    prevEnquiryDataMap.set(variantId, sum / count);
                }
            });
        }
    
    
        let productPricesData = [];
        let adPer = 0;
        let cvdPer = 0;
    
        for (const product of enquiryProducts) {
            const currentProductShrimpQty = containerProductsMap.get(product.group) || product.shrimpQty; // Fallback to product's own shrimpQty if not in map
            if (currentProductShrimpQty === 0) {
                // Skip product or return error if shrimp quantity is zero, to avoid division by zero errors later
                // console.warn(`Product ${product.variantId} has zero shrimp quantity. Skipping.`);
                // Potentially add a placeholder or specific error for this product.
                // For now, we might let it error out later if a division by zero occurs, or handle it:
                // return new CommonResponse(false,0,`Product ${product.variantId} has zero shrimp quantity.`);
                continue; // Or handle as an error for the specific product
            }
    
    
            const yieldVal = yieldPerMap.get(product.variantId);
            if (yieldVal == null || yieldVal <= 0) {
                if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                    await transmanager.releaseTransaction();
                }
                return new CommonResponse(false, 0, `Yield not found or is invalid for product variant ${product.variantId}`);
            }
    
            let frozenyield = yieldVal;
            if (product.styleWeighment == StyleWeighmentEnum.FWFC || product.styleWeighment == StyleWeighmentEnum.NWFC) {
                frozenyield = Number(yieldVal) + Number(yieldVal * (product.glaze / 100));
            }
            if (frozenyield <= 0) {
                 return new CommonResponse(false, 0, `Frozen yield is zero or invalid for product variant ${product.variantId}`);
            }
    
    
            const packCount = product.packCount;
            // CRITICAL: Validate this rmCount formula against your business logic and rm_rates table keying.
            // This formula seems unusual. packCount is typically pcs/lb or pcs/kg.
            // yieldVal and frozenyield are percentages (e.g., 70 for 70%).
            // Standard way to calculate RM count (e.g. pieces/kg of RM):
            // piecesPerKgFinished = packCount (if pcs/kg) or packCount / 0.454 (if pcs/lb)
            // rmCountPiecesPerKg = piecesPerKgFinished / (yieldAsDecimal e.g. 0.70)
            let rmCount;
            const yieldDecimal = yieldVal / 100;
            const frozenYieldDecimal = frozenyield / 100;
    
            if (product.styleWeighment == StyleWeighmentEnum.FWFC || product.styleWeighment == StyleWeighmentEnum.NWFC) {
                // Original: rmCount = Math.round(1000/((454/packCount/frozenyield)*100))
                // Assuming packCount is pcs/lb and frozenyield is percentage (e.g. 70 means 70%)
                // This means: 1000 grams / (grams_per_piece_raw_material)
                // grams_per_piece_finished = 454 / packCount
                // grams_per_piece_raw = grams_per_piece_finished / frozenYieldDecimal
                // rmCount (pcs_per_kg_raw) = 1000 / grams_per_piece_raw
                rmCount = Math.round(1000 / ( (454 / packCount) / frozenYieldDecimal ) );
            } else {
                // Original: rmCount = Math.round(1000/((454/packCount/yieldVal)*100))
                rmCount = Math.round(1000 / ( (454 / packCount) / yieldDecimal ) );
            }
    
    
            const rmRate = rmratesMap.get(rmCount);
            if (rmRate == null) { // Use null check for map get
                if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                    await transmanager.releaseTransaction();
                }
                return new CommonResponse(false, 0, `RM rate not found for the calculated count ${rmCount} of product ${product.variantId}`);
            }
            const rmCost = Math.round(rmRate / yieldDecimal); // Cost of RM per kg of yielded product
    
            const peelingKey = {
                foodTypeId: product.foodTypeId,
                valaddOneId: product.valoneId,
                valaddTwoId: product.valtwoId,
                valaddThreeId: product.valthreeId,
                minGrade: Number(product.minGrade),
                maxGrade: Number(product.maxGrade)
            };
            const peelingCostStr = peelingrateMap.get(JSON.stringify(peelingKey));
            if (peelingCostStr == null) {
                if (transmanager && typeof transmanager.releaseTransaction === 'function') {
                    await transmanager.releaseTransaction();
                }
                return new CommonResponse(false, 0, `Peeling cost is not defined for product ${product.variantId} with attributes ${JSON.stringify(peelingKey)}`);
            }
            const peelingCost = Number(peelingCostStr);
    
            const mfgRatesForAll = mfgRatesMap.get('ALL');
            if (!mfgRatesForAll) {
                 if (transmanager && typeof transmanager.releaseTransaction === 'function') { await transmanager.releaseTransaction(); }
                return new CostingSheetResponse(false, 0, "MFG rates for 'ALL' category not found, critical for calculation.");
            }
            const mfgRatesForCategory = mfgRatesMap.get(product.category) || { withBoilerCost: 0, withoutBoilerCost: 0 }; // Default if category specific not found
    
            let mfgComponentCost = product.foodTypeId == GlobalVariableValues.cookingId ?
                Number(mfgRatesForAll.withBoilerCost + mfgRatesForCategory.withBoilerCost) :
                Number(mfgRatesForAll.withoutBoilerCost + mfgRatesForCategory.withoutBoilerCost);
            const mfgCost = Math.round(mfgComponentCost + peelingCost);
    
            const saleCommPer = enquiryInfoData[0].saleCommissionPercentage;
            // product.shrimpQty was reassigned to currentProductShrimpQty
            const saleCommission = currentProductShrimpQty === 0 ? 0 : Math.round(((currentProductShrimpQty / 0.454) * (saleCommPer / 100) * (exchangeRate[0].exchangeRate)) / currentProductShrimpQty);
            
            const packmaterailCost = product.packMaterialCost;
    
            // The '+4' to exchangeRate is unusual and should be verified. Using it as per original.
            const ocaenFreightPerKgLocalCurrency = finalOceanFreightInUsd === 0 || currentProductShrimpQty === 0 ? 0 : (finalOceanFreightInUsd * (Number(exchangeRate[0].exchangeRate) + 4)) / currentProductShrimpQty;
    
            let totalGlobalPricePerKg = 0;
            let percentageSum = 0; // Sum of percentage-based global prices
    
            globalPricesData.forEach(priceRec => {
                if (priceRec.type == GlobalPriceType.Value) {
                    totalGlobalPricePerKg += currentProductShrimpQty === 0 ? 0 : (Number(priceRec.price) / Number(currentProductShrimpQty));
                }
                if (priceRec.component == 'Antidumping duty') {
                    adPer = Number(priceRec.price); // Assuming price is the percentage
                }
                if (priceRec.component == 'CVD') {
                    cvdPer = Number(priceRec.price); // Assuming price is the percentage
                }
                if (priceRec.type == GlobalPriceType.Percentage) {
                    percentageSum += Number(priceRec.price);
                }
            });
    
            const freightAndForwardExp = Math.round(ocaenFreightPerKgLocalCurrency + totalGlobalPricePerKg);
            // fixedCost is SUM(price) from fixed_prices_chart, this is likely a per KG or per unit cost.
            // If it's a total fixed cost for an operation, it needs to be distributed over total production quantity.
            // Assuming enquiryFixedCost is per KG for now.
            const totalExpenses = Math.round(mfgCost + Number(saleCommission) + Number(packmaterailCost) + Number(freightAndForwardExp) + enquiryFixedCost);
            
            // Cost of production: (Total Expenses + RM Cost) per LB USD
            const costOfProductionPerLbUSD = currentProductShrimpQty === 0 || exchangeRate[0].exchangeRate === 0 ? 0 : Number((((totalExpenses + rmCost) / exchangeRate[0].exchangeRate) * 0.454).toFixed(2));
    
            const costOfSalesPerKgINR = rmCost + totalExpenses;
            const costOfSalesPerKgUSD = exchangeRate[0].exchangeRate === 0 ? 0 : Number((costOfSalesPerKgINR / exchangeRate[0].exchangeRate).toFixed(2));
            const costOfSaleUSDLBBase = Number(costOfSalesPerKgUSD * 0.454); // Base cost per LB in USD before country-specific additions
            const costOfSalesPerLBUSD = Number(costOfSaleUSDLBBase.toFixed(2));
    
            let percentageValAmount = 0; // This is the monetary value of percentageSum for USA
            let totalCostOfSalesPerLBUSD_final = costOfSalesPerLBUSD; // Final total cost per LB USD
    
            if (enquiryInfoData[0].country == 'USA') {
                // percentageSum includes AD, CVD etc. if they are percentages from global_price_chart
                percentageValAmount = costOfSaleUSDLBBase * (percentageSum / 100);
                totalCostOfSalesPerLBUSD_final = Number((costOfSalesPerLBUSD + percentageValAmount).toFixed(2));
            }
    
            let quotePrice = 0; // Placeholder, original logic does not seem to set this from calculations.
            let addedPriceToRmrate = 0; // Placeholder
            let reducedPriceToRmRate = 0; // Placeholder
            let saleCostToAddedRmrate = 0; // Placeholder
            let saleCostToReducedRmrate = 0; // Placeholder
            let incentives = 0; // Placeholder
    
            let buyerOfferPrice = 0;
            let netProfitLoss = 0;
            let totalProfitLoss = 0; // From stored buyer offer if exists
            let plPercentage = 0;    // From stored buyer offer if exists
            let contributionPercentage = 0; // From stored buyer offer if exists
            
            const oceanFreightPrLbUSD = currentProductShrimpQty === 0 || finalOceanFreightInUsd === 0 ? 0 : (finalOceanFreightInUsd) / (currentProductShrimpQty / 0.454);
    
            if (product.buyerOfferPrice > 0 && !buyerOfferPriceFlag) {
                buyerOfferPrice = product.buyerOfferPrice;
                let costForPLCalc = costOfSalesPerLBUSD; // Default to base LB cost
    
                if (enquiryInfoData[0].country == 'USA') {
                    // Recalculate percentageValAmount based on (buyerOfferPrice - oceanFreightPrLbUSD) for USA duties
                    // This creates a dynamic total cost based on the offer price itself for duty calculation.
                    const valueForUSADutyCalc = buyerOfferPrice - oceanFreightPrLbUSD;
                    const dynamicPercentageValAmount = valueForUSADutyCalc * (percentageSum / 100);
                    percentageValAmount = dynamicPercentageValAmount; // Update for storage if this path taken
                    costForPLCalc = Number((costOfSaleUSDLBBase + dynamicPercentageValAmount).toFixed(2));
                    totalCostOfSalesPerLBUSD_final = costForPLCalc; // Update final total cost
                }
    
                if (product.priceUOM == 2) { // Price in LB
                    netProfitLoss = Number((buyerOfferPrice - costForPLCalc).toFixed(2));
                } else { // Price in KG
                    // For KG comparison, need costOfSalesPerKgUSD + USA specific % additions if applicable.
                    let costOfSalesPerKgUSD_with_USA_extras = costOfSalesPerKgUSD;
                    if (enquiryInfoData[0].country == 'USA') {
                         // Convert buyerOfferPrice (per KG) to USD for duty base
                        const buyerOfferPriceUSDPerKg = exchangeRate[0].exchangeRate === 0 ? buyerOfferPrice : buyerOfferPrice / exchangeRate[0].exchangeRate;
                        const oceanFreightPerKgUSD = currentProductShrimpQty === 0 || finalOceanFreightInUsd === 0 ? 0 : finalOceanFreightInUsd / currentProductShrimpQty;
                        const valueForUSADutyCalcKg = buyerOfferPriceUSDPerKg - oceanFreightPerKgUSD;
                        const dynamicPercentageValAmountKgUSD = valueForUSADutyCalcKg * (percentageSum / 100);
                        costOfSalesPerKgUSD_with_USA_extras = Number((costOfSalesPerKgUSD + dynamicPercentageValAmountKgUSD).toFixed(2));
                    }
                    netProfitLoss = Number((buyerOfferPrice - costOfSalesPerKgUSD_with_USA_extras).toFixed(2)); // Assuming buyerOfferPrice here is also in USD if priceUOM != 2
                                                                                                             // If buyerOfferPrice for KG is in local currency, it needs conversion first for PL.
                                                                                                             // The original code did not explicitly convert buyerOfferPrice if UOM was KG.
                                                                                                             // This needs clarification: Is buyerOfferPrice always in USD?
                }
            } else if (buyerOfferPriceFlag) {
                const offerData = buyerPriceDataMap.get(product.variantId);
                if (offerData) {
                    buyerOfferPrice = offerData.buyerOfferPrice;
                    netProfitLoss = offerData.netPLOnBuyerPrice; // This PL is as stored
                    totalProfitLoss = offerData.totalProfitLoss;
                    plPercentage = offerData.plPercentage;
                    contributionPercentage = offerData.contributionPercentage;
    
                    // Recalculate totalCostOfSalesPerLBUSD_final for USA if buyerOfferPrice from map is used
                    if (enquiryInfoData[0].country == 'USA') {
                        const valueForUSADutyCalc = buyerOfferPrice - oceanFreightPrLbUSD;
                        const dynamicPercentageValAmount = valueForUSADutyCalc * (percentageSum / 100);
                        percentageValAmount = dynamicPercentageValAmount;
                        totalCostOfSalesPerLBUSD_final = Number((costOfSaleUSDLBBase + dynamicPercentageValAmount).toFixed(2));
                    }
                }
            }
    
            let prevConfirmedPrice = 0;
            const prevailingMarketRate = ProductPriceInfoMap.get(product.variantId) != null ? ProductPriceInfoMap.get(product.variantId) : 0;
            
            if (sameBuyerEnquiryFlag && sameBuyerEnquiriesMap.has(product.variantId)) {
                prevConfirmedPrice = Number(Number(sameBuyerEnquiriesMap.get(product.variantId)).toFixed(2));
            } else if (prevenquiriesFlag && prevEnquiryDataMap.has(product.variantId)) {
                prevConfirmedPrice = Number(parseFloat(String(prevEnquiryDataMap.get(product.variantId))).toFixed(2));
            }
    
    
            const productName = `${product.variant || 'N/A'}/${product.packStyle || 'N/A'}`;
            const productObj = new productRates(
                product.variantId, currentProductShrimpQty, productName, product.leadType, yieldVal, packCount, rmCount, rmRate, rmCost, mfgCost,
                saleCommPer, saleCommission, packmaterailCost, freightAndForwardExp, totalExpenses, costOfProductionPerLbUSD, enquiryFixedCost, /*fixedCostPerUnit?*/
                costOfSalesPerKgINR, costOfSalesPerKgUSD, costOfSalesPerLBUSD, // Base CoS/LB
                quotePrice, buyerOfferPrice, netProfitLoss, incentives,
                totalProfitLoss, plPercentage, contributionPercentage,
                prevConfirmedPrice, prevailingMarketRate,
                addedPriceToRmrate, reducedPriceToRmRate, saleCostToAddedRmrate, saleCostToReducedRmrate,
                product.styleWeighment, product.category, frozenyield,
                enquiryInfoData[0].country == 'USA' ? Number(percentageValAmount.toFixed(2)) : 0, // Monetary value of % duties
                totalCostOfSalesPerLBUSD_final, // Final CoS/LB including specific duties
                product.group, product.cartons, product.containers, product.enquiryProductId, product.netWeight
            );
            productObj.peelingRate = Number(peelingCost);
            productObj.priceUOM = product.priceUOM;
            productObj.qtyUOM = product.uomId;
            productPricesData.push(productObj);
        }
        const destinationData = await this.destinationService.getDestinationById({ destinationId: req.destinationId });
        const resData = new CostSheetModel(
            enquiryInfoData[0].buyer, enquiryInfoData[0].agent, enquiryInfoData[0].country, enquiryInfoData[0].destination,
            enquiryInfoData[0].shipTerms, finalOceanFreightInUsd, enquiryInfoData[0].shipmentPeriod,
            enquiryInfoData[0].noOfContainers, enquiryInfoData[0].enquiryDate,
            datesInfo && datesInfo[0] ? datesInfo[0].assesmentApprovalDate : null,
            datesInfo && datesInfo[0] ? datesInfo[0].QuoteSentDate : null,
            datesInfo && datesInfo[0] ? datesInfo[0].Accepteddate : null,
            exchangeRate[0].exchangeRate, enquiryInfoData[0].enquiryStatus, productPricesData,
            enquiryInfoData[0].country == 'USA' ? adPer : 0, // adPer from global prices
            enquiryInfoData[0].country == 'USA' ? cvdPer : 0, // cvdPer from global prices
            enquiryInfoData[0].enquiryNumber
        );

        const costSheetInfo = [resData];
        const oceanFreightRate = await this.getOcenFrightOfEnquiry(null, req.destinationId);
    
        const oceanFreightInUsd =
            enquiryInfoData[0].isFOB == 0 ? 0 : oceanFreightRate[0].oceanFreightRateUSD;   
        const costsheetdata = await this.getCostSheetInfo(new EnquiryIdreq(req.enquiryid)); 
        if (enquiryInfoData.length > 0) {
            const additionalProductRates = costsheetdata?.data?.[0]?.productRates || [];
            const oceanFreightFromCostSheetData = parseFloat(String(costsheetdata?.data?.[0]?.OceanFrightInUSD ?? '0'));
    
            const enrichedAdditionalRates = additionalProductRates.map(item => ({
                ...item,
                oceanFreightInUsd: oceanFreightFromCostSheetData,
            }));
    
            // const enrichedCostSheetRates = costSheetInfo.map(item => ({
            //     ...item,
            //     oceanFreightInUsd: oceanFreightInUsd,
            // }));

            const enrichedCostSheetRates = costSheetInfo[0].productRates.map(item => ({
                ...item,
                oceanFreightInUsd: oceanFreightInUsd,
                productName: `${item.productName} (${destinationData.data.destinationName})`

            }));
            
    
            const maxLength = Math.max(enrichedAdditionalRates.length, enrichedCostSheetRates.length);
            const combinedProductRates: any[] = [];
    
            for (let i = 0; i < maxLength; i++) {
                if (enrichedAdditionalRates[i]) combinedProductRates.push(enrichedAdditionalRates[i]);
                if (enrichedCostSheetRates[i]) combinedProductRates.push(enrichedCostSheetRates[i]);
            }
    
            const finalData = new CostSheetModel(
                enquiryInfoData[0].buyer,
                enquiryInfoData[0].agent,
                enquiryInfoData[0].country,
                destinationData.data.destinationName,
                enquiryInfoData[0].shipTerms,
                oceanFreightInUsd,
                enquiryInfoData[0].shipmentPeriod,
                enquiryInfoData[0].noOfContainers,
                enquiryInfoData[0].enquiryDate,
                datesInfo[0].assesmentApprovalDate,
                datesInfo[0].QuoteSentDate,
                datesInfo[0].Accepteddate,
                exchangeRate[0].exchangeRate,
                enquiryInfoData[0].enquiryStatus,
                combinedProductRates, // merged and interleaved productRates with oceanFreightInUsd
                costSheetInfo[0]?.ad || 0,
                costSheetInfo[0]?.cvd || 0,
                enquiryInfoData[0].enquiryNumber
            );
    
            return new CostingSheetResponse(true, 1, 'Data Retrieved', [finalData]);
        } else {
            return new CostingSheetResponse(false, 0, 'No data Found for selected Enquiry');
        }
    }
    
    


}